import { render, staticRenderFns } from "./ExpertSection.vue?vue&type=template&id=7c526fc6&scoped=true&"
import script from "./ExpertSection.vue?vue&type=script&lang=js&"
export * from "./ExpertSection.vue?vue&type=script&lang=js&"
import style0 from "./ExpertSection.vue?vue&type=style&index=0&id=7c526fc6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c526fc6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
